const redirectToGeneral = () => {
  const redirect = encodeURIComponent(window.location.href);

  const loginUrl = window.location.href.includes('localhost')
    ? `http://localhost:8888/?redirect=${redirect}`
    : `https://general.aula.education/?redirect=${redirect}`;

  return window.location.replace(loginUrl);
};

export const redirectToGeneralAfterLogOut = () => {
  if (window.location.href.includes('localhost')) {
    return window.location.replace('http://localhost:8888/#/select');
  }
  return window.location.replace('https://general.aula.education/#/select');
};

export default redirectToGeneral;
